export const LeaseCompFieldsList = [
  { label: "Property Name", key: "propertyName" },
  { label: "Address", key: "propertyAddress" },
  { label: "City", key: "propertyCity" },
  { label: "State", key: "propertyState" },
  { label: "Postal Code", key: "propertyPostalCode" },
  { label: "County", key: "propertyCounty" },
  { label: "Latitude", key: "latitude" },
  { label: "Longitude", key: "longitude" },
  { label: "Market", key: "market" },
  { label: "Submarket", key: "submarket" },
  { label: "Property Type", key: "propertyType" },
  { label: "Property Subtype", key: "propertySubtype" },
  { label: "Property Class", key: "propertyClass" },
  { label: "Property Size", key: "propertySize" },
  { label: "Area Leased", key: "areaLeased" },
  { label: "Suite", key: "suite" },
  { label: "Floor", key: "floor" },
  { label: "Tenant", key: "tenant" },
  { label: "Lessor / Landlord", key: "lessor" },
  { label: "Lease Type", key: "leaseType" },
  { label: "Lease Rate Type", key: "leaseRateType" },
  { label: "Transaction Type", key: "leaseTransactionType" },
  { label: "Lease Term", key: "leaseTerm" },
  { label: "Start Date", key: "startDate" },
  { label: "End Date", key: "endDate" },
  { label: "Signed Date", key: "signedDate" },
  { label: "Occupancy Date", key: "occupancyDate" },
  { label: "Base Rent (Yearly)", key: "baseRentYearly" },
  { label: "Base Rent (Monthly)", key: "baseRentMonthly" },
  { label: "Effective Rent (Yearly)", key: "effectiveRentYearly" },
  { label: "Effective Rent (Monthly)", key: "effectiveRentMonthly" },
  { label: "Escalation %", key: "escalationPercent" },
  { label: "TI Allowance", key: "tiAllowance" },
  { label: "Free Rent", key: "freeRent" },
  { label: "Operating Expenses", key: "opex" },
  { label: "Other Concessions", key: "otherConcessions" },
  { label: "In-Place Rent", key: "inPlaceRent" },
  { label: "Confidentiality", key: "confidentiality" },
  { label: "Source", key: "source" },
];

export default LeaseCompFieldsList;

// Header mapping for Excel import auto-matching
export const LeaseCompHeaderMapping: Record<string, string> = {
  "Property Name": "propertyName",
  Name: "propertyName",
  Address: "propertyAddress",
  "Property Address": "propertyAddress",
  City: "propertyCity",
  State: "propertyState",
  ZIP: "propertyPostalCode",
  "Zip Code": "propertyPostalCode",
  "Postal Code": "propertyPostalCode",
  "Property County": "propertyCounty",
  County: "propertyCounty",
  Latitude: "latitude",
  Longitude: "longitude",
  Lat: "latitude",
  Lng: "longitude",
  Long: "longitude",
  Market: "market",
  Submarket: "submarket",
  "Property Type": "propertyType",
  "Property Class": "propertyClass",
  "Property Size": "propertySize",
  "Building Size": "propertySize",
  RBA: "propertySize",
  "Area Leased": "areaLeased",
  "Leased SF": "areaLeased",
  Suite: "suite",
  Floor: "floor",
  Tenant: "tenant",
  Lessor: "lessor",
  Landlord: "lessor",
  "Lease Type": "leaseType",
  "Lease Rate Type": "leaseRateType",
  "Transaction Type": "leaseTransactionType",
  "Lease Term": "leaseTerm",
  Term: "leaseTerm",
  "Start Date": "startDate",
  "Commencement Date": "startDate",
  "End Date": "endDate",
  "Expiration Date": "endDate",
  "Signed Date": "signedDate",
  "Execution Date": "signedDate",
  "Occupancy Date": "occupancyDate",
  "Base Rent": "baseRentYearly",
  "Base Rent (Yearly)": "baseRentYearly",
  "Base Rent Yearly": "baseRentYearly",
  "Base Rent (Monthly)": "baseRentMonthly",
  "Base Rent Monthly": "baseRentMonthly",
  "Effective Rent": "effectiveRentYearly",
  "Effective Rent (Yearly)": "effectiveRentYearly",
  "Effective Rent Yearly": "effectiveRentYearly",
  "Effective Rent (Monthly)": "effectiveRentMonthly",
  "Effective Rent Monthly": "effectiveRentMonthly",
  "Escalation %": "escalationPercent",
  "Escalation Percent": "escalationPercent",
  Escalation: "escalationPercent",
  "TI Allowance": "tiAllowance",
  "Tenant Improvement": "tiAllowance",
  "Free Rent": "freeRent",
  "Operating Expenses": "opex",
  OpEx: "opex",
  "Other Concessions": "otherConcessions",
  "In-Place Rent": "inPlaceRent",
  "In Place Rent": "inPlaceRent",
  Confidentiality: "confidentiality",
  Source: "source",
};

export const generateLeaseCompHeaderMapping = () => {
  return Object.entries(LeaseCompHeaderMapping).map(([header, key]) => ({
    header,
    matchedAttribute: key,
  }));
};
